// @flow
import { useField } from 'formik'
import * as React from 'react'
import ErrorLabel from 'ui/atoms/ErrorLabel'
import DateField, { type Props as DateProps } from 'ui/molecules/DateField'

type Props = {
  ...DateProps,
  value?: any,
  onChange?: any,
  name: string,
}

function FormikDateField({ name, ...rest }: Props): React.Node {
  const [field, meta, helpers] = useField(name)

  return (
    <div>
      <DateField
        {...rest}
        clearWhenInvalid
        hasError={meta.touched && meta.error}
        name={field.name}
        onBlur={field.onBlur}
        onChange={(value) => helpers.setValue(value ? value[1] : '')}
        value={field.value}
      />
      <ErrorLabel>{meta.touched && meta.error}</ErrorLabel>
    </div>
  )
}

export default FormikDateField
